const dateFormat = 'DD/MM/YYYY';
const dateFormatEn = 'DD MMM YYYY';
/** Thai Buddhist Era short date, e.g. 16/08/2569 */
const dateFormatThai = 'DD/MM/BBBB';
const dateYearFormatEn = dateFormatThai;
/** Thai Buddhist Era long date, e.g. 16 สิงหาคม 2569 */
const dateFormatTH = 'DD MMMM BBBB';
const dateTimeFormat = 'DD/MM/YYYY HH:mm';
const hourMinFormat = 'HH:mm';

export {
  dateFormat,
  dateTimeFormat,
  hourMinFormat,
  dateFormatEn,
  dateFormatTH,
  dateFormatThai,
  dateYearFormatEn,
};
